import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface ChatBotNode {
  node: number;
  content:string
  modalOn: boolean;
}

export const chatbotSlice = createSlice({
  name: "chatbot",
  initialState: { node: -1, content:"",modalOn: false },
  reducers: {
    setModal: (state: ChatBotNode, action: PayloadAction<ChatBotNode>) => {
      return action.payload;
    },
  },
});

export default chatbotSlice.reducer;